import React, { useState } from 'react';
import { compose } from 'redux';

import Form from '../MainForm';
import InputCheckbox from '../InputCheckbox';
import { Row } from '../../Structure';

import {
  withQualificationsActions,
  withScreenActions,
} from '../../../hocs/withActions';
import { withQualificationsData, withScreenData } from '../../../hocs/withData';
import InputTitle from '../InputTitle';

const OtherQualificationsForm = ({
  QualificationsData = {},
  SaveQualificationsForm = () => { },
  EnableSpinner = () => { },
}) => {
  const [values, setValues] = useState(QualificationsData);

  const handleSubmit = (event) => {
    event.preventDefault();
    const formattedValues = { ...values };
    EnableSpinner();
    SaveQualificationsForm({ ...formattedValues });
  };

  const updateChecked = (event) => {
    const { name, checked } = event;

    values[name] = checked;
    setValues({ ...values });
    // QualificationsFields({ ...values });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <InputCheckbox
          name="hseQualification"
          onChange={updateChecked}
          required
          checked={values.hseQualification}
        >
          <strong>
            NOCN or CITB Health, safety and environment test (HS&E) passed within 2 years of the date of application received*
          </strong>
        </InputCheckbox>
      </Row>
      <Row>
        <InputCheckbox
          name="testPassed"
          onChange={updateChecked}
          required
          checked={values.testPassed}
        >
          <strong>
            CPCS Renewal CPD course completed within 2 years of the date of the
            application received.*
          </strong>
        </InputCheckbox>
      </Row>
      <Row>
        <InputCheckbox
          name="signedLogbook"
          onChange={updateChecked}
          required
          checked={values.signedLogbook}
        >
          <strong>
            I confirm that the applicant has completed the required logbook
            hours, and/or for categories A61/A62/A68, I will upload the
            Competence Assessment Forms.*
          </strong>
        </InputCheckbox>
      </Row>
      <Row>
        <InputCheckbox
          name="vqUnitsConforming"
          onChange={updateChecked}
          checked={values.vqUnitsConforming}
        >
          The applicant has previously completed an NVQ or SVQ in a
          Construction/Plant related qualification or has completed the
          Competence Interview.
        </InputCheckbox>
      </Row>
    </Form>
  );
};

export default compose(
  withQualificationsActions,
  withQualificationsData,
  withScreenData,
  withScreenActions
)(OtherQualificationsForm);
